import {
  doc,
  setDoc,
  getDoc,
  getDocs,
  deleteDoc,
  collection,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';

export function buildPickId(leagueId, uid, matchId) {
  return `${leagueId}_${uid}_${matchId}`;
}

/**
 * Save (create or overwrite) a pick.
 * round is needed so Firestore security rules can check round status.
 */
export async function savePick(leagueId, uid, matchId, pickedTeamId, round) {
  const pickId = buildPickId(leagueId, uid, matchId);
  await setDoc(doc(db, 'picks', pickId), {
    leagueId,
    userId: uid,
    matchId,
    pickedTeamId,
    round,
    pointsEarned: null,
    isUnique: false,
  });
}

/**
 * Remove a pick (deselect). Only valid while round is open.
 */
export async function deletePick(leagueId, uid, matchId) {
  await deleteDoc(doc(db, 'picks', buildPickId(leagueId, uid, matchId)));
}

export async function getUserPickForMatch(leagueId, uid, matchId) {
  const snap = await getDoc(doc(db, 'picks', buildPickId(leagueId, uid, matchId)));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function getUserPicksForLeague(leagueId, uid) {
  const q = query(
    collection(db, 'picks'),
    where('leagueId', '==', leagueId),
    where('userId', '==', uid)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getLeaguePicksForMatch(leagueId, matchId) {
  const q = query(
    collection(db, 'picks'),
    where('leagueId', '==', leagueId),
    where('matchId', '==', matchId)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
